import { AI_API_URI } from "../config/api"
import client from "../config/client"

import {
	Dataset,
	Summary,
	GetDatasetFileActionResponse
} from "../lib/types"

export async function getDatasetFileAction(
	fileName: string
): Promise<GetDatasetFileActionResponse> {
	const url = new URL(`${AI_API_URI}/v1/dataset/csv/${fileName}`)

	return (await client(url.toString())).data
}

export async function createSummaryAction(dataset: string, createSummaryUrl?: string): Promise<Summary> {
	const url = createSummaryUrl ? createSummaryUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/create-summary`

	return (await client.post(url)).data
}

export async function getSummaryAction(dataset: string, getSummaryUrl?: string): Promise<Dataset> {
	const url = getSummaryUrl ? getSummaryUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/get-summary`
	
	return (await client(url)).data
}

export async function createDatasetPromptAction(
	dataset: string,
	body: { 
		prompt: string,
		context: string
	},
	createDatasetPromptUrl?: string
) {
	const url = createDatasetPromptUrl ? createDatasetPromptUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/prompt`

	return (await client.post(url, body)).data
}

export async function createDatasetStepsAction(
	dataset: string,
	body: {
		prompt: string,
		answer: string,
		chat_memory: string[]
	},
	createDatasetStepsUrl?: string
) {
	const url = createDatasetStepsUrl ? createDatasetStepsUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/prompt/steps`

	return (await client.post(url, body)).data
}

export async function createQuickMessages(
	dataset: string,
	body: {
		messages: string[]
	},
	createQuickMessagesUrl?: string
) {
	const url = createQuickMessagesUrl ? createQuickMessagesUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/quick-messages`

	return (await client.post(url, body)).data
}

export async function clearConversationAction(dataset: string, clearConversationUrl?: string): Promise<{ message: string }> {
	const url = clearConversationUrl ? clearConversationUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/clear-conversation`

	return (await client.post(url)).data
}

export async function audioToText(dataset: string, audioFile: Blob, audioToTextUrl?: string){
	const formData = new FormData();
	formData.append('audio_file', audioFile);

	const url = audioToTextUrl ? audioToTextUrl : `${AI_API_URI}/v1/whitelabel/${dataset}/audio-to-text-endpoint`

	return (await client.post(url, formData)).data
}